import { Typography } from "@commonlibs";
import clsx from "clsx";
import Callout from "ui/common/components/feedback/Callout/Callout";
import TabsModalFooter from "ui/common/components/feedback/TabsModal/TabsModalFooter/TabsModalFooter";
import useCloseTabModal from "ui/common/components/feedback/TabsModal/hooks/useCloseTabModal";
import Form from "ui/common/components/input/Form/Form";
import useTranslate from "ui/locale/hooks/useTranslate";
import { UpdateTermsAndPrivacyState } from "./UpdateTermsAndPrivacyModal.types";
import useTabsState from "ui/common/components/feedback/TabsModal/hooks/useTabsState";
import useUpdateTermsPrivacy from "features/terms/hooks/useUpdateTermsPrivacy";

export interface ConfirmUpdateTermsAndPrivacyTabProps {
    className?: string;
    style?: React.CSSProperties;
}

export default function ConfirmUpdateTermsAndPrivacyTab({ className, ...rest }: ConfirmUpdateTermsAndPrivacyTabProps) {
    const translate = useTranslate();
    const closeModal = useCloseTabModal();

    const { mutate: updateTermsPrivacy, isLoading } = useUpdateTermsPrivacy({ onSettled: closeModal });

    const [{ termsAndConditions, personalDataTreatmentAuthorization, privacyPolicy }] = useTabsState<UpdateTermsAndPrivacyState>();

    function handleSubmit() {
        updateTermsPrivacy({ termsAndConditions, personalDataTreatmentAuthorization, privacyPolicy });
    }

    return (
        <Form className={clsx("confirm-update-terms-privacy-tab", className)} onSubmit={handleSubmit} {...rest}>
            <Callout status="warning" text={translate("updateTermsPrivacyCallout")} />
            <Typography variant="body3Strong" light textAlign="justify">
                {translate("updateTermsPrivacyText")}
            </Typography>

            <TabsModalFooter mainType="submit" mainLabel={translate("confirm")} isLoading={isLoading} />
        </Form>
    );
}
